// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarRank_wrapper__1xpTT","content":"BarRank_content__2B3uq"};